import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface CustomCheckboxProps {
    labelKey: string;
    checked: boolean;
    disabled?: boolean;
    onClick: () => void;
    labelClassName?: string;
    labelDisabledClassName?: string;
    checkboxClassName?: string;
    checkboxDisabledClassName?: string;
    checkboxCheckedClassName?: string;
    wrapClassName?: string;
    additionalLayoutElement?: ReactNode;
}

const CustomCheckbox: FC<CustomCheckboxProps> = (props) => {
    const { t } = useTranslation();
    const handleClick = () => {
        if (!props.disabled) {
            props.onClick();
        }
    };

    return (
        <div className={props.wrapClassName}>
            <div
                onClick={handleClick}
                className={`${props.checkboxClassName} ${props.checked ? props.checkboxCheckedClassName : ""} ${
                    props.disabled ? props.checkboxDisabledClassName : ""
                }`}
            >
                {props.checked && props.additionalLayoutElement}
            </div>
            {props.labelKey && (
                <span className={`${props.labelClassName} ${props.disabled ? props.labelDisabledClassName : ""}`}>
                    {t(props.labelKey)}
                </span>
            )}
        </div>
    );
};

export default CustomCheckbox;
